import React, { useRef } from 'react';
import PageIcon from '@atlaskit/icon/glyph/page';
import {
	CommandShortcuts,
	COMMAND_PALETTE_SECTIONS,
	COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY,
} from '@atlassian/jira-command-palette-common';
import { useIntl } from '@atlassian/jira-intl';
import { SearchField } from '@atlassian/jira-searchfield';
import { useShortcutAnalytics } from '@atlassian/jira-software-keyboard-shortcuts';
import { usePullRequestTableOptionsStore } from '../../../../../../../controllers/pull-request-filters';
import messages from './messages';

type SearchFilterProps = {
	disabled: boolean;
};

export const SearchFilter = ({ disabled }: SearchFilterProps) => {
	const searchInputRef = useRef<HTMLInputElement>(null);
	const { formatMessage } = useIntl();
	const [pullRequestTableOptions, actions] = usePullRequestTableOptionsStore();
	const fireShortcutAnalytics = useShortcutAnalytics('code');
	const focusSearchInput = () => {
		if (searchInputRef?.current != null) {
			requestAnimationFrame(() => {
				searchInputRef.current && searchInputRef.current.focus();
			});
			const analyticsPayload = {
				id: 'focusSearchField',
				key: 'f',
				attributes: {},
			};
			fireShortcutAnalytics(analyticsPayload);
		}
	};

	return (
		<>
			<CommandShortcuts
				keyMap={{
					f: {
						callback: focusSearchInput,
						registerInCommandPalette: {
							id: 'code-focus-search-input',
							name: formatMessage(messages.searchCurrentPage),
							priority: COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY.searchOnCurrentPage,
							section: COMMAND_PALETTE_SECTIONS.quickActions,
							components: {
								LeftIcon: () => <PageIcon label={formatMessage(messages.searchCurrentPage)} />,
							},
							analytics: {
								action: 'searchCurrentPage',
							},
						},
					},
				}}
				location="code.pull-requests.keyboard-shortcuts"
			/>
			<SearchField
				data-testid="software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.search-filter.search-field"
				value={pullRequestTableOptions.titleFilter}
				isDisabled={disabled}
				isAlwaysExpanded
				isAutocompleteDisabled
				ariaLabelText={formatMessage(messages.searchLabel)}
				placeholder={formatMessage(messages.searchInputPlaceHolderText)}
				placeholderAlwaysVisible
				onChange={(e: string) => {
					actions.setTitleFilter(e);
				}}
				inputRef={searchInputRef}
			/>
		</>
	);
};
